import roleTree, {
    ROLE_DSS,
    ROLE_CASE_NURSE,
    ROLE_EDC_API,
    ROLE_ADMIN,
    ROLE_READ_WRITE,
    ROLE_READ_ONLY,
    ROLE_DASHBOARD
} from './role-tree';

export const isGranted = (state, getters, rootState) => (roleToCheck) => {
  return checkRoles(rootState?.tokenData?.roles, roleToCheck);
}

export const isStandardDashboardUser = (state, getters) => {
    return getters['isGranted'](ROLE_DASHBOARD);
}

export const hasReadOnlyAccess = (state, getters, rootState) => {
    return getters['isGranted'](ROLE_READ_ONLY) && !getters['isGranted'](ROLE_READ_WRITE);
}

export const hasDSSAccess = (state, getters, rootState) => {
    if (getters['isGranted'](ROLE_DSS))
        return true;

    if (getters['isGranted'](ROLE_CASE_NURSE)){
        if (rootState?.patientSummary?.targetVersion){
            return rootState.patientSummary.targetVersion <= 2;
        }
    }

    return false;
}

export const hasDSSTitrationAccess = (state, getters) => {
    return getters['isGranted'](ROLE_DSS);
}

export const canEditVisitData = (state, getters, rootState, rootGetters) => (visitNumber) => {
    if (getters['hasReadOnlyAccess']){
        return false;
    }

    // Admins can always edit every visit data.
    if (getters['isGranted'](ROLE_ADMIN)){
        return true;
    }

    visitNumber = parseInt(visitNumber);
    let encounter = null;

    // If the requested version is less than the target version (version of current inprogress encounter, or the first next encounter)
    if (visitNumber <= rootState.patientSummary.targetVersion || rootState.patientSummary.targetVersion === null){
        encounter = rootGetters['patientSummary/getEncounter'](visitNumber);

        // The requested encounter was not skipped
        if (!encounter || encounter.status !== 'skipped'){
            // Visit number 1 is EDC data that comes in from EDC sync, and should not be editable by the case nurse
            // Users who have the ROLE_EDC_API can edit the data (this should only be the EDC API user itself, or admins)
            if (visitNumber === 1){
                return getters['isGranted'](ROLE_EDC_API);
            }else{
                return true;
            }
        }
    }

    return false;
}

function checkRoles(userRoles, roleToCheck){
  if (!(userRoles && userRoles.length))
    return false;

  for (let i=0; i<userRoles.length; i++){
    if (checkRole(userRoles[i], roleToCheck))
      return true;
  }

  return false;
}

function checkRole(userRole, roleToCheck){
   if (userRole === roleToCheck)
     return true;

   if (roleTree[userRole]){
     const userRoleChildren = roleTree[userRole];
     for (let i=0; i<userRoleChildren.length; i++){
       if (checkRole(userRoleChildren[i], roleToCheck))
         return true;
     }
   }

   return false;
}

export const preferredLipidsUnit = (state) => state.preferredLipidsUnit || 'mg/dL';

export const preferredGlucoseUnit = (state) => state.preferredGlucoseUnit || '%';
